var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/GlobalThemeProvider/GlobalThemeProvider.tsx",
  _this = this;
import React, { useEffect } from 'react';
import { ThemeProvider as ReactJSSThemeProvider } from 'react-jss';
import { getClientEnvironmentDetails } from '@sm/utils';
var GlobalThemeProvider = function GlobalThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isBrowser = _getClientEnvironment.isBrowser;
  useEffect(function () {
    /**
     *  remove the JSS styles from the DOM after the client has loaded
     *  https://cssinjs.org/react-jss?v=v10.4.0#server-side-rendering
     */
    if (isBrowser) {
      var jss = document.getElementById('jss');
      if (jss) {
        jss.remove();
      }
    }
  }, [isBrowser]);
  return /*#__PURE__*/React.createElement(ReactJSSThemeProvider, {
    theme: theme,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, children);
};
export default GlobalThemeProvider;
//# sourceMappingURL=GlobalThemeProvider.js.map